import { SettingOutlined } from "@ant-design/icons";
import { AccountSettingsPage } from "components/AccountSettings/AccountSettingsPage.tsx";
import { createAccountFileRoute } from "utils/createAccountFileRoute.ts";

export const Route = createAccountFileRoute("/_authenticated/account/_layout/settings/")({
    component: AccountSettingsPage,
    staticData: {
        permissions: [],
        isPublic: true,
        showInSideMenu: true,
        label: "pages.account.settings.title",
        icon: <SettingOutlined />,
        sort: 3,
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.account.settings.title"),
    }),
});
